import { render, staticRenderFns } from "./ModalMghrwcLogin.vue?vue&type=template&id=248933a6&scoped=true&"
import script from "./ModalMghrwcLogin.vue?vue&type=script&lang=ts&"
export * from "./ModalMghrwcLogin.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMghrwcLogin.vue?vue&type=style&index=0&id=248933a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248933a6",
  null
  
)

export default component.exports